import React from 'react';
import { Button } from '@material-ui/core';
import { _ } from '../../functions/translator.js';
import Checkbox from '@material-ui/core/Checkbox';

function CustomCardTypesButton (props) {
    return (
        <Button
            onClick={props.onClick}
            size='small'
            className={`customcard-types-button ${props.disabled && 'disabled'}`}
        >
            {!props.disabled && <Checkbox className='customcard-type-checkbox' color="primary" checked={props.selected} />}
            <i className={`mdi ${props.disabled? 'mdi-lock-outline' : props.icon } ml-2`}></i>
            <p className='mr-1 ml-1' style={{ fontSize: '11px', lineHeight: '1' }}>{props.title}</p>
        </Button>
    );
}

export default CustomCardTypesButton;
